export default __webpack_public_path__ + "static/media/VC-Logo.a66fa759.png";